<template>
  <div class="friends-site">
    <!-- <video
      id="video"
      v-show="showVideo"
      class="video"
      :src="videoSrc"
      controls
    ></video> -->
    <div class="page-help content">
      <div class="title">
        {{ $t("newHome.friendsSite") }}
      </div>
      <carousel
        @changeShowVideo="$emit('changeShowVideo', $event)"
        :images="images"
        style="margin:auto"
        :showVideo="showVideo"
      />
    </div>
  </div>
</template>
<script>
import Carousel from "@/components/topSection/carousel.vue";
import { api, baseURL } from "@/api";
export default {
  name: "friendsSite",
  components: {
    Carousel
  },
  props: ["showVideo"],
  data() {
    return {
      images: []
    };
  },
  mounted() {
    this.getImages();
  },
  methods: {
    getImages() {
      api
        .getBanners()
        .then(res => {
          for (var i = 0; i < res.data.data.length; i++) {
            this.images.push(baseURL + res.data.data[i].image);
          }
        })
        .catch(e => {
          console.log(e);
        });
    }
  }
};
</script>
<style lang="scss" scoped>
.friends-site {
  width: 100%;
  background-color: $gray-blue-400;
  padding-bottom: 173px;
  text-align: left;
  .content {
    .title {
      font-weight: 600;
      font-style: SemiBold;
      font-size: 36px;
      line-height: 66px;
      letter-spacing: 0%;
      color: $blue-1000;
      margin: 0;
      margin-bottom: 67px;
    }
  }
}
</style>
